import styles from '@styles/components/Novedades/NovedadesInasistencias.module.css';
import { useCallback, useEffect, useState } from 'react';
// import Table from '@components/General/Table';
import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';
import { ReactComponent as ArrowsSVG } from '@assets/SVGs/QontactPoint/ArrowSVG.svg';

import { usePopup } from '@contexts/popupContext';
import ConfirmarNovedad from './ConfirmarNovedad';
import RemoverInasistencia from './RemoverInasistencia';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';

// import '@styles/Debugging.css'
import Image from '@components/General/Image';
import { NovedadPickerPopper } from '@components/General/TablePoppers';
import { APIIntegration, apiConfig } from '@integrations/APIIntegration';
import ConfirmationPopup from '@components/General/ConfirmationPopup';
import { NovedadesService } from '@services/NovedadesService';
import { Application } from '@core/Application';
import { HorizontalContainer } from '@shared/designSystem/Containers';
import SearchBar from '@shared/designSystem/SearchBar';
import { RefreshButton} from '@shared/designSystem/Button';
import designSystemStyles from '@shared/styles/designSystemStyles';
import { QontyLoading } from '@components/QontyLoading';
import { QontyEmptyState } from '@components/QontyEmptyState';


const Inasistencia = ({index, style, row, orgNovedades, orgID, removeRFIFromList}) => {
    const {showPopup} = usePopup()
    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const [selectedNovedad, setSelectedNovedad] = useState(null)


    const processName = (name) => {
        const words = name.split(' ');
        const processedWords = words.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const restOfWord = word.slice(1).toLowerCase();
            return firstLetter + restOfWord;
        });
        return processedWords.join(' ');        
    }

    const handleClickOnDiv = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen) => !previousOpen);
    };


    const handleCerrarInasistencia = async () => {
        let httpClient = Application.shared().coreDependencies.httpClient

        let service = new NovedadesService(
            httpClient
        )

        let response = await service.closeRequestForInformation(row.id)
    }

    return (
        <div className={styles['inasistencia-container']} style={index % 2 === 0 ? {...style, background: '#FBFBFB'} : {...style, background: '#FFF'}}>
            <div className={styles['inasistencia-colaborador-container']}>
                <div className={styles['circle-mask']}  style={{display: 'flex', width: '24px', height: '24px', marginRight: '10px', verticalAlign: 'top'}}>
                    <Image src={row.photo || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}}/>
                </div>
                <div className={styles['inasistencia-name-container']}>
                    {processName(row.colaborador)}
                </div>
            </div>
            <div className={styles['inasistencia-fecha-container']}>{row.fecha}</div>
            <div className={styles['inasistencia-novedad-container']}>
                <div className={styles['novedades-input-container']} onClick={handleClickOnDiv}>
                    {!selectedNovedad ?
                        <>
                            Seleccionar
                        </>
                        : 
                        <>
                            <div className={styles['novedadpicker-svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                {selectedNovedad.acronym}
                            </div>

                            <p className={styles['novedadpicker-dropdown-text']}>{selectedNovedad.name}</p>
                        </>

                    }

                    <div className={styles['svg-container']} style={{marginLeft: 'auto', width: '10px', height: '10px',
                        transform: open ? 'none' : 'rotate(180deg)',
                        transition: 'transform 0.2s ease'
                    }}>
                        <ArrowsSVG/>
                    </div>
                </div>
                {open && <NovedadPickerPopper 
                    isOpen={open} 
                    anchorElement={anchorEl} 
                    placement='bottom' 
                    clickAwayHandler={() => setOpen(false)}
                    novedades={orgNovedades}
                    selectedNovedad={selectedNovedad}
                    setSelectedNovedad={setSelectedNovedad}
                />}
            </div>
            <div className={styles['inasistencia-actions-container']}>
                <div className={styles['inasistencia-action-container']}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 19 20" fill="none"style={{cursor: 'pointer'}}  onClick={() => showPopup(() => 
                        <ConfirmationPopup
                            title="Cancelar Inasistencia"
                            message={<span>
                                ¿Estás seguro que quieres cerrar la inasistencia de <span style={{fontWeight: 700}}>{row.colaborador}</span>?
                            </span>}
                            onConfirm={handleCerrarInasistencia}
                            onSuccess={() => removeRFIFromList(row.id)}
                            successMessage={"Cerrado inasistencia correctamente".localized()}
                            errorMessage={"Error al cerrar inasistencia".localized()}
                            confirmButtonText ={'Eliminar'.localized()}
                            cancelButtonText ={'Cancelar'.localized()}
                        />, false)}
                    >
                        <path d="M16.154 7.53711C16.154 7.53711 15.6257 14.0902 15.3192 16.8506C15.1732 18.1691 14.3588 18.9416 13.0248 18.9659C10.4863 19.0117 7.94482 19.0146 5.40724 18.9611C4.12386 18.9348 3.32308 18.1525 3.18005 16.8575C2.87161 14.0727 2.34619 7.53711 2.34619 7.53711" stroke="#EC6C56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.5001 4.39453H1" stroke="#EC6C56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.3208 4.39479C13.557 4.39479 12.8992 3.85478 12.7494 3.10654L12.5129 1.92338C12.367 1.37752 11.8727 1 11.3093 1H7.19063C6.62726 1 6.13298 1.37752 5.98703 1.92338L5.75059 3.10654C5.60075 3.85478 4.943 4.39479 4.1792 4.39479" stroke="#EC6C56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className={styles['inasistencia-action-container']}>
                    {!selectedNovedad ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 26 26" fill="none">
                            <circle cx="13" cy="13" r="12.25" stroke="#DDDDDD" stroke-width="1.5"/>
                            <path d="M17.8847 9.5332L10.9513 16.4665L7.7998 13.315" stroke="#DDDDDD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    :
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 26 26" fill="none" style={{cursor: 'pointer'}} onClick={() => showPopup(() => 
                            <ConfirmarNovedad
                                onDone={() => removeRFIFromList(row.id)}
                                row={row}
                                orgID={orgID}
                                colaborador={row.colaborador}
                                fecha={row.fecha}
                                novedad={selectedNovedad}
                            />, false)}
                        >
                            <circle cx="13" cy="13" r="12.25" stroke="#667085" stroke-width="1.5"/>
                            <path d="M17.8849 9.5332L10.9516 16.4665L7.80005 13.315" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                </div>
            </div>

        </div>

    )
}




export default function NovedadesInasistencias ({orgID}) {
    const [lastKey, setLastKey] = useState('');
	const [hasMore, setHasMore] = useState(true);

	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState([]);
	const [novedades, setNovedades] = useState([]);
	const [searchField, setSearchField] = useState('');

    
	const fetchInasistencias = useCallback(
		async (key = '', isInitial = false) => {
			if (isInitial) setLoading(true);

            const novedadesService = Application.shared().coreDependencies.novedadesService

			try {    
                const result = await novedadesService.getInasistenciasPaginated(orgID, key, 50);

				setLastKey(result.newLastKey);
				setHasMore(result.data.length > 0);
				setResponse((prev) => [
					...(isInitial ? [] : prev), // if initial, discard old; otherwise append
					...result.data.map((row) => ({
						id: row.id,
						photo: row.userImageURL,
						colaborador: row.userName,
						fecha: row.day,
						novedad: null,
					})),
				]);
			} catch (err) {
				console.error(err);
			} finally {
				if (isInitial) setLoading(false);
			}
		},
		[orgID],
	);

	const fetchNovedades = useCallback(async () => {
		try {
            const novedadesService = Application.shared().coreDependencies.novedadesService
            const result = await novedadesService.getNovedades(orgID);
			setNovedades(result);
		} catch (err) {
			console.error(err);
		}
	}, [orgID]);

    const removeRFIFromResponse = (id) => {
        setResponse((prev) => prev.filter((r) => r.id !== id));
    }

	// initial load when orgID changes
	useEffect(() => {
		setResponse([]); // reset old data
		setLastKey('');
		setHasMore(true);
		fetchInasistencias('', true);
		fetchNovedades();
	}, [orgID, fetchInasistencias, fetchNovedades]);

	// filter by search
	const filteredResponse = response.filter((r) =>
		r.colaborador
			.toLowerCase()
			.replace(/\s/g, '')
			.includes(searchField.toLowerCase().replace(/\s/g, '')),
	);
  
    const itemCount = hasMore ? filteredResponse.length + 1 : filteredResponse.length
    const isItemLoaded = idx => !hasMore || idx < filteredResponse.length
    const emptyText = response.length === 0
        ? "No hay ninguna inasistencia aun.".localized()
        : "No hay información para esta búsqueda.".localized();

    const loadingView = (
        <QontyLoading
            text={"Cargando inasistencias...".localized()}
            withQonty={true}
        />
    );

    const emptyView = (
        <QontyEmptyState
            text={emptyText}
            darkMode={false}
        />
    );

    return (
        <>
        <HorizontalContainer
            paddingBottom={designSystemStyles.paddingMd}
        >
            <SearchBar
                placeholder={"Buscar colaborador".localized()}
                value={searchField}
                onChange={setSearchField}
                width="350px"
            />
            <RefreshButton
                onClick={ () => fetchInasistencias('', true)}
            />
        </HorizontalContainer>

        <div className={styles['table-container']}>
            {loading
                ? loadingView
                : filteredResponse.length === 0
                    ? emptyView
                    : (
                <AutoSizer>
                {({ height, width }) => (
                    <InfiniteLoader
                    isItemLoaded={isItemLoaded}
                    itemCount={itemCount}
                    loadMoreItems={() =>
                        hasMore
                        ? fetchInasistencias(lastKey, false)
                        : Promise.resolve()
                    }
                    >
                    {({ onItemsRendered, ref }) => (
                        <List
                        height={height}
                        width={width}
                        itemCount={itemCount}
                        itemSize={60}
                        onItemsRendered={onItemsRendered}
                        ref={ref}
                        >
                        {({ index, style }) => {
                            if (!isItemLoaded(index)) {
                            return (
                                <div style={style} className={styles['loading-row']}>
                                <QontyLoading />
                                </div>
                            )
                            }
                            return (
                            <Inasistencia
                                key={index}
                                index={index}
                                style={style}
                                row={filteredResponse[index]}
                                orgNovedades={novedades}
                                orgID={orgID}
                                removeRFIFromList={removeRFIFromResponse}
                            />
                            )
                        }}
                        </List>
                    )}
                    </InfiniteLoader>
                )}
                </AutoSizer>
            )}
        </div>
        </>
    )
}
